import {Component} from '@angular/core';

export interface ICustomFeatureIconsComponent {}

@Component({
  selector: 'app-custom-feature-icons',
  standalone: true,
  imports: [],
  templateUrl: './custom-feature-icons.component.html',
  styleUrl: './custom-feature-icons.component.scss'
})
export class CustomFeatureIconsComponent implements ICustomFeatureIconsComponent{

}
